import { render, staticRenderFns } from "./complaintFormDetail.vue?vue&type=template&id=21702250&scoped=true"
import script from "./complaintFormDetail.vue?vue&type=script&lang=js"
export * from "./complaintFormDetail.vue?vue&type=script&lang=js"
import style0 from "./complaintFormDetail.vue?vue&type=style&index=0&id=21702250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21702250",
  null
  
)

export default component.exports